module.exports = __webpack_public_path__ + "img/icon-check-circle-red.30e3198f.svg";